export enum ECCPLocationStatus {
  NEW = "N",
  CHECKED = "C",
}
